import { Booking } from '../types/qraphql/booking.type';
import { Locations } from '../scheme/locations';
import { BookingLocation } from '../types/booking-location.type';

export const getLocation = (booking: Booking): BookingLocation | undefined => {
    return Locations.find(
        (location) => location.propertyId === booking.property.id,
    );
};

export const getDefaultLocation = (): BookingLocation => {
    return Locations[0];
};
